import { render, staticRenderFns } from "./subject-heading-new.vue?vue&type=template&id=4a4ca9f2&scoped=true"
import script from "./subject-heading-new.vue?vue&type=script&lang=js"
export * from "./subject-heading-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4ca9f2",
  null
  
)

export default component.exports